import { notificationsServiceAgent } from 'src/api/notifications-service-agent';
import { throwApiError } from 'src/api/utils';
import type { IAuthService } from 'src/app/auth/AuthStore';

export type TAlertNotificationSize = 'SMALL' | 'LARGE';

export type TAlertWellGroupScope = 'ALL' | 'ACTIVE' | 'FAVORITES';

export type TAlertRiskLevel = 'NO_RISK' | 'LOW_RISK' | 'MED_RISK' | 'HIGH_RISK';

export type TNotificationSettingsForAlertType = {
  showInfoWindows: boolean;
  soundAlert: boolean;
  showRecommendations: boolean;
};

export type TAlertsPersonalSetting = {
  configId?: number;
  alertTypes: {
    alertRules: TNotificationSettingsForAlertType;
    manual: TNotificationSettingsForAlertType;
  };
  notificationSize: TAlertNotificationSize;
  wellGroups: TAlertWellGroupScope;
  minRisk: TAlertRiskLevel;
  periodTimeSeconds: number | null;
  periodDepth: number | null;
  durationDisplayNotificationSeconds: number | null;
  minRiskForScreenFlicker: TAlertRiskLevel;
  screenFlickerCount: number | null;
};

export function getDefaultAlertsPersonalSettings(): TAlertsPersonalSetting {
  return {
    alertTypes: {
      alertRules: {
        showInfoWindows: true,
        soundAlert: true,
        showRecommendations: true,
      },
      manual: {
        showInfoWindows: true,
        soundAlert: true,
        showRecommendations: false,
      },
    },
    notificationSize: 'SMALL',
    wellGroups: 'ACTIVE',
    minRisk: 'HIGH_RISK',
    periodTimeSeconds: 60,
    periodDepth: 1,
    durationDisplayNotificationSeconds: 10,
    minRiskForScreenFlicker: 'HIGH_RISK',
    screenFlickerCount: 3,
  };
}

export class AlertsPersonalSettingsApi {
  private readonly auth: IAuthService;

  constructor(auth: IAuthService) {
    this.auth = auth;
  }

  loadPreferences(): Promise<TAlertsPersonalSetting> {
    return notificationsServiceAgent
      .get<{ data: TAlertsPersonalSetting[] }>('/configs')
      .then((res) => res.data.data.at(0) ?? getDefaultAlertsPersonalSettings())
      .catch((e) => {
        console.error(e);
        return getDefaultAlertsPersonalSettings();
      });
  }

  updatePreferences(
    settings: TAlertsPersonalSetting,
    abortController?: AbortController,
  ): Promise<TAlertsPersonalSetting> {
    const method = settings.configId ? notificationsServiceAgent.put : notificationsServiceAgent.post;
    return method<TAlertsPersonalSetting>('/configs', settings, {
      signal: abortController?.signal,
    })
      .then((res) => res.data)
      .catch((error) => {
        throwApiError(error);
      });
  }
}
